/* eslint-disable no-console */
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    deferredPrompt: undefined,
    windowSize: window.innerWidth,
  }),
  computed: {
    ...mapGetters([
      '_T',
      'domainBasedBrand',
      'currentBrand',
      'pwa_config',
    ]),
    brand() {
      if (this.domainBasedBrand) {
        return this.currentBrand.name
      }
      return 'Goorder'
    },
    logo() {
      if (this.pwa_config.icons && this.pwa_config.icons.length) {
        return this.pwa_config.icons[0].src
      }
      return ''
    }
  }, 
  methods: {
    showInstallPopup() {
      //check if mobile and cookie set then don't show
      const pwaInstalled = localStorage.getItem('pwa_installed')
      console.log(pwaInstalled, this.windowSize)
      if (this.windowSize < 576 && pwaInstalled) {
        return false
      }
      //show popup here
      this.$store
        .dispatch('showNotification', {
          text: this._T(`${'Install ' + this.brand + ' App ?'}`),
          sub_text:`(${this._T('it\'s less than 1MB')})`,
          status: 'success',
          static: true,
          hideBackdrop: true,
          centerAligned: false,
          custom_icon: this.logo,
          web_theme: true,
          ok_button: {
            label: 'OK',
            callback: () => {
              //do something here
              this.installPWA()
            },
          },
          cancel_button: {
            label: 'Cancel',
            callback: () => {
              //do something here
              this.hideInstallPopup()
            },
          },
        })
    },

    hideInstallPopup() {
      //hide the install popup
      this.$store.dispatch('hideNotification')
    },
    
    async installPWA() {
      // Hide the app provided install promotion
      this.hideInstallPopup()
      // Show the install prompt
      //NOTE: this .prompt() can not be called without human interaction so call it on click event
      this.deferredPrompt.prompt()
      // Wait for the user to respond to the prompt
      const { outcome } = await this.deferredPrompt.userChoice
      // Optionally, send analytics event with outcome of user choice
      console.log(`User response to the install prompt: ${outcome}`)
      // We've used the prompt, and can't use it again, throw it away
      this.deferredPrompt = null
    },

    getPWADisplayMode() {
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches
      if (document.referrer.startsWith('android-app://')) {
        return 'twa'
      } else if (navigator.standalone || isStandalone) {
        return 'standalone'
      }
      return 'browser'
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowSize = window.innerWidth
    })

    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault()
      // Stash the event so it can be triggered later.
      this.deferredPrompt = e
      // Update UI notify the user they can install the PWA
      this.showInstallPopup()
      // Optionally, send analytics event that PWA install promo was shown.
      console.log(`'beforeinstallprompt' event was fired.`)
    })

    window.addEventListener('appinstalled', () => {
      // Hide the app-provided install promotion
      this.hideInstallPopup()
      // Clear the deferredPrompt so it can be garbage collected
      this.deferredPrompt = null
      //in future we may set a time i.e current time and show this message again once in a month
      localStorage.setItem('pwa_installed', true)
      // Optionally, send analytics event to indicate successful install
      console.log('PWA was installed')
    })

    window.matchMedia('(display-mode: standalone)').addEventListener('change', (evt) => {
      let displayMode = 'browser'
      if (evt.matches) {
        displayMode = 'standalone'
      }
      // Log display mode change to analytics
      console.log('DISPLAY_MODE_CHANGED', displayMode)
    })
  },
}
